import T from "./ghl-ui.es1589.js";
import y from "./ghl-ui.es1590.js";
import m from "./ghl-ui.es1586.js";
import v from "./ghl-ui.es1587.js";
import h from "./ghl-ui.es1588.js";
import c from "./ghl-ui.es1591.js";
import { Parser as k } from "./ghl-ui.es1670.js";
import { mapValue as n, parseNDigits as f, normalizeTwoDigitYear as D } from "./ghl-ui.es1671.js";
import g from "./ghl-ui.es1581.js";
import p from "./ghl-ui.es1467.js";
var I = /* @__PURE__ */ function(Y) {
  v(o, Y);
  var u = h(o);
  function o() {
    var i;
    T(this, o);
    for (var r = arguments.length, e = new Array(r), a = 0; a < r; a++)
      e[a] = arguments[a];
    return i = u.call.apply(u, [this].concat(e)), c(m(i), "priority", 130), c(m(i), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), i;
  }
  return y(o, [{
    key: "parse",
    value: function(r, e, a) {
      var t = function(s) {
        return {
          year: s,
          isTwoDigitYear: e === "YY"
        };
      };
      switch (e) {
        case "Y":
          return n(f(4, r), t);
        case "Yo":
          return n(a.ordinalNumber(r, {
            unit: "year"
          }), t);
        default:
          return n(f(e.length, r), t);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e.isTwoDigitYear || e.year > 0;
    }
  }, {
    key: "set",
    value: function(r, e, a, t) {
      var l = g(r, t);
      if (a.isTwoDigitYear) {
        var s = D(a.year, l);
        return r.setUTCFullYear(s, 0, t.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), p(r, t);
      }
      var C = !("era" in e) || e.era === 1 ? a.year : 1 - a.year;
      return r.setUTCFullYear(C, 0, t.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), p(r, t);
    }
  }]), o;
}(k);
export {
  I as LocalWeekYearParser
};
